export default __webpack_public_path__ + "static/media/garen_card.1defbcaa.png";